import { BaseMutations } from '@/store/base-mutations';
import { AnalyticsSections } from '@/enums';
import AnalyticsState from './state';
import {
  Analytics, Users, Organizations, Categories, OperatioTypes, RepairsTypes, Clients, AnalyticsFilters, Orders, CreditLineContract,
} from '../types';

export default class AnalyticsMutations extends BaseMutations<AnalyticsState> {
  SET_ANALYTICS(analytics: Analytics.Section) {
    this.state.analytics = analytics;
  }

  SET_USERS(users: Users[]) {
    this.state.users = users;
  }

  SET_ORGANIZATIONS(orgs: Organizations[]) {
    this.state.organizations = orgs;
  }

  SET_EXTERNAL_ORG(items: string[]) {
    this.state.external_organization = items;
  }

  SET_CATEGORIES(categories: Categories[]) {
    this.state.categories = categories;
  }

  SET_OPERATION_TYPES(items: OperatioTypes[]) {
    this.state.operation_types = items;
  }

  SET_REPAIRS_TYPES(items: RepairsTypes[]) {
    this.state.repair_types = items;
  }

  SET_REGIONS(items: string[]) {
    this.state.lead_regions = items;
  }

  SET_CLIENTS(items: Clients[]) {
    this.state.clients = items;
  }

  SET_ORDER_SIDE_NUMBERS(items: string[]) {
    this.state.order_side_numbers = items;
  }

  SET_YEARS(items: string[]) {
    this.state.years = items;
  }

  SET_CREDIT_LINE_CONTRACTS(items: CreditLineContract[]) {
    this.state.credit_line_contracts = items;
  }

  SET_RESPONSE_FILTERS(items: Orders) {
    switch (this.state.section) {
      case AnalyticsSections.ORDERS:
        return this.state.response_filters.orders = items;

      case AnalyticsSections.CERTS:
        return this.state.response_filters.certs = items;

      case AnalyticsSections.RETURNS_ZIP:
        return this.state.response_filters.returns_zip = items;

      case AnalyticsSections.ORDER_SIDES:
        return this.state.response_filters.order_sides = items;

      case AnalyticsSections.REPAIR_MODELS:
        return this.state.response_filters.repair_models = items;

      case AnalyticsSections.LEADS:
        return this.state.response_filters.leads = items;

      case AnalyticsSections.REPAIR_TYPES:
        return this.state.response_filters.repair_types = items;

      case AnalyticsSections.RESULT_SERVICE_ACTIVITY:
        return this.state.response_filters.result_service_activity = items;

      case AnalyticsSections.CREDIT_LINE:
        return this.state.response_filters.credit_line = items;

      default:
        return null;
    }
  }

  UPD_FILTER_KEY({ key, value, section }: { key: keyof AnalyticsFilters, value: unknown, section: string }) {
    this.state.filters[key] = value;
    this.state.section = section;
  }

  TOGGLE_SECTION_LOADING(value: boolean) {
    switch (this.state.section) {
      case AnalyticsSections.ORDERS:
        return this.state.orders_loading = value;

      case AnalyticsSections.CERTS:
        return this.state.certs_loading = value;

      case AnalyticsSections.RETURNS_ZIP:
        return this.state.returns_zip_loading = value;

      case AnalyticsSections.ORDER_SIDES:
        return this.state.order_sides_loading = value;

      case AnalyticsSections.REPAIR_MODELS:
        return this.state.repair_models_loading = value;

      case AnalyticsSections.LEADS:
        return this.state.leads_loading = value;

      case AnalyticsSections.REPAIR_TYPES:
        return this.state.repair_types_loading = value;

      case AnalyticsSections.RESULT_SERVICE_ACTIVITY:
        return this.state.result_service_activity_loading = value;

      case AnalyticsSections.CREDIT_LINE:
        return this.state.credit_line_loading = value;

      default:
        return null;
    }
  }

  CLEAR_SECTION() {
    this.state.section = '';
  }
}
